module.exports = __webpack_public_path__ + "img/crew3_7-8-2021.9de70b57.jpg";